import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdLabelQueryKey, type Options, postEntitiesByFpIdLabelMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { ApiError, PostEntitiesByFpIdLabelData, PostEntitiesByFpIdLabelResponse } from '@onefootprint/request-types/dashboard';
import { useMutation, useQueryClient } from '@tanstack/react-query';
const useEditLabel = () => {
  const $ = _c(12);
  const showErrorToast = useRequestErrorToast();
  const queryClient = useQueryClient();
  const queryKey = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = postEntitiesByFpIdLabelMutation();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== queryClient) {
    t1 = async t2 => {
      const {
        body: t3,
        path: t4
      } = t2;
      const {
        kind
      } = t3;
      const {
        fpId
      } = t4;
      await queryClient.cancelQueries({
        queryKey: queryKey(fpId)
      });
      const previousLabel = queryClient.getQueryData(queryKey(fpId));
      queryClient.setQueryData(queryKey(fpId), old => ({
        ...old,
        id: fpId,
        kind
      }));
      return {
        previousLabel
      };
    };
    $[1] = queryClient;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== queryClient || $[4] !== showErrorToast) {
    t2 = (err, t3, context) => {
      const {
        path: t4
      } = t3;
      const {
        fpId: fpId_0
      } = t4;
      showErrorToast(err);
      if (context?.previousLabel) {
        queryClient.setQueryData(queryKey(fpId_0), context.previousLabel);
      }
    };
    $[3] = queryClient;
    $[4] = showErrorToast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== queryClient) {
    t3 = (_, t4) => {
      const {
        path: t5
      } = t4;
      const {
        fpId: fpId_1
      } = t5;
      queryClient.invalidateQueries({
        queryKey: queryKey(fpId_1)
      });
    };
    $[6] = queryClient;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = {
      ...t0,
      onMutate: t1,
      onError: t2,
      onSuccess: t3
    };
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return useMutation(t4);
};
export default useEditLabel;
function _temp(id) {
  return getEntitiesByFpIdLabelQueryKey({
    path: {
      fpId: id
    }
  });
}